import React, { Component } from 'react';
import { Grid, Row, Col, ButtonToolbar, Button, Form, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import Select from "react-select";

import { decode } from 'jsonwebtoken';

import { PropTypes } from 'prop-types';

import { ImportCommand } from '../../commands/ImportCommand';
import { EditionsCommand } from '../../commands/EditionsCommand';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { HandleDialog } from '../../../HandleDialog';
import { TitleRow } from '../../../TitleRow';
import { TokenDecodeHelper } from '../../../helpers/TokenDecodeHelper';
import { storage, TOKEN_INFO } from '../../../../app/Storage';

import { Progressbar } from '../../../Progressbar';

export class MatchProviderStep extends Component {
    static contextTypes = {
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            commands: {
                import: new ImportCommand(),
                editions: new EditionsCommand()
            },
            dependencies: {
                systemProviders: [],
                editions: []
            },
            form: {
                matches: [], // AT
                providers: [],
                networkEdition: null === props.networkEdition || undefined === props.networkEdition ? 0 : props.networkEdition
            },
            styles: {
                providers: null
            },
            actions: {
                isLoadingDependencies: [],
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    componentDidMount() {
        this.context.addEditionObserver(this);

        const { isTransportAuthority } = this.props;

        if (!isTransportAuthority) {
            return;
        }

        const { providers } = this.props;
        const { commands, dependencies, form, actions } = this.state;

        // Decode Transport Authority Providers
        let tokenInfo = storage.get(TOKEN_INFO);
        dependencies.systemProviders = TokenDecodeHelper.getAvailableProviders(tokenInfo, (a) => decode(a))
            .map(provider => {
                const a = provider.split(":");

                return {
                    id: a[0],
                    name: a[1]
                };
            })
            .filter(provider => "0" !== provider.id);

        // Get Providers Network Editions
        dependencies.systemProviders.forEach(provider => {
            actions.isLoadingDependencies.push({
                isLoading: true,
                dependencie: provider.id
            });

            commands.editions.getImportable(
                "network",
                provider.id,
                (a) => this.onGetProviderEditionsSuccessCallback(provider.id, a),
                (a) => this.onGetProviderEditionsErrorCallback(provider.id, a)
            );
        });

        // Update form with default values
        form.matches = providers.map(provider => {
            return {
                readProvider: provider,
                systemProvider: null,
                networkEdition: null
            }
        });

        this.setState({
            dependencies: dependencies,
            form: form,
            actions: actions
        });
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    onGetProviderEditionsSuccessCallback(providerId, editions) {
        const { actions } = this.state;

        const action = actions.isLoadingDependencies.find(a => a.dependencie === providerId);
        action.isLoading = false;

        this.setState({
            actions: actions
        });

        if (!Array.isArray(editions) || 0 === editions.length) {
            return;
        }

        const { dependencies } = this.state;

        editions.forEach(edition => {
            dependencies.editions.push({
                providerId: providerId,
                id: edition.id,
                name: edition.name
            });
        });

        this.setState({
            dependencies: dependencies
        });
    }

    onGetProviderEditionsErrorCallback(providerId, error) {
        const { actions } = this.state;

        const action = actions.isLoadingDependencies.find(a => a.dependencie === providerId);
        action.isLoading = false;

        this.setState({
            actions: actions
        });

        this.props.onUpdateStep(error);
    }

    onImportSuccessCallback(result) {        
        const message = {
            show: true,
            message: this.renderProgressBar("isRunning", "", result, (a) => this.checkImportComplete(a.id)),
            style: "primary",
            title: "A Carregar os Dados...",
            icon: "transfer",
            noButtons: true
        };

        this.props.onUpdateStep(message);
    }

    onImportErrorCallback(error) {
        this.props.onUpdateStep({
            show: true,
            message: this.renderProgressBar('Error', error),
            style: "danger",
            title: "Erro",
            icon: "remove"
        }, "uploadFile");
    }

    checkImportComplete(taskId) {
        const { commands } = this.state;

        commands.import.completeImportProviderData(
            taskId,
            (a) => this.completeImportProviderDataSuccessCallback(a),
            (a) => this.onImportErrorCallback(a)
        );
    }

    completeImportProviderDataSuccessCallback(result) {
        const message = {
            show: true,
            message: this.renderProgressBar("Success"),
            style: "success",
            title: "Sucesso",
            icon: "ok"
        };
        this.props.onUpdateStep(message, "uploadFile");
    }

    // ----------------------

    onImportTransportAuthorityData(commands, form, taskId) {
        const data = form.matches
            .map(match => {
                return {
                    readProvider: match.readProvider,
                    systemProvider: null === match.systemProvider ? 0 : match.systemProvider.id,
                    networkEdition: null === match.networkEdition ? 0 : match.networkEdition.id
                };
            });

        commands.import.matchProviders(
            taskId,
            data,
            (a) => this.onImportSuccessCallback(a),
            (a) => this.onImportErrorCallback(a)
        );
    }

    onImportProviderData(commands, form, taskId) {
        if (!this.isProviderFormValid(form)) {
            return;
        }

        const data = form.providers.map(provider => {
            return {
                readProvider: provider,
                networkEdition: form.networkEdition
            };
        });

        commands.import.matchProviders(
            taskId,
            data,
            (a) => this.onImportSuccessCallback(a),
            (a) => this.onImportErrorCallback(a)
        );
    }

    onImport() {
        const { isTransportAuthority, id } = this.props;
        const { commands, form } = this.state;

        isTransportAuthority ?
            this.onImportTransportAuthorityData(commands, form, id) :
            this.onImportProviderData(commands, form, id);
    }

    onCancel() {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: "Tem a certeza que cancelar a importação",
                style: "warning",
                icon: "alert",
                argument: undefined
            }
        });
    }

    onSelectTransportAuthorityFormValue(match, target, property) {
        const { form } = this.state;

        const formMatch = form.matches.find(m => m === match);
        if (undefined === formMatch) {
            return;
        }

        formMatch[property] = target;

        this.setState({
            form: form
        });
    }

    onSelectProviderFormValue(target, property) {
        const { form } = this.state;

        form[property] = target;

        this.setState({
            form: form
        });
    }

    onExitDialog(isToExecute, _) {
        if (isToExecute) {
            this.props.onChangeStep("uploadFile", {});
        }

        this.setState({
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ----------------------

    isProviderFormValid(form) {
        let output = true;
        const styles = {
            providers: null
        };

        if (!Array.isArray(form.providers) || !form.providers.some(_ => true)) {
            output = false;
            styles.providers = "error";
        };

        this.setState({
            styles: styles
        });

        return output;
    }

    // ----------------------

    renderTransportAuthorityForm(form) {
        const { dependencies } = this.state;

        return (
            <TransportAuthorityMatchProviderStepForm
                providers={dependencies.systemProviders}
                editions={dependencies.editions}
                form={{ matches: form.matches }}
                onSelectValue={(a, b, c) => this.onSelectTransportAuthorityFormValue(a, b, c)} />
        );
    }

    renderProviderForm(form, styles) {
        const { providers } = this.props;

        return (
            <ProviderMatchProviderStepForm
                providers={providers}
                form={{ providers: form.providers }}
                styles={styles}
                onSelectValue={(a, b) => this.onSelectProviderFormValue(a, b)} />
        );
    }

    renderForm(styles, isTransportAuthority) {
        const { actions } = this.state;

        if (actions.isLoadingDependencies.some(loading => loading.isLoading)) {
            return (
                <LoadingSpinner />
            );
        }

        const { form } = this.state;

        if (isTransportAuthority) {
            return (
                <React.Fragment>
                    {this.renderTransportAuthorityForm(form)}
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {this.renderProviderForm(form, styles)}
            </React.Fragment >
        );
    }

    renderProgressBar(statusMessage, message, data, successCallback = undefined) {
        return (
            <Progressbar statusMessage={statusMessage} 
                message={message} 
                data={data}
                success={successCallback}
                error={(a) => this.onImportErrorCallback(a)} />
        );
    }

    render() {
        const { isTransportAuthority } = this.props;
        const { styles, dialog } = this.state;

        return (
            <div>
                <div>
                    <TitleRow title="Importação de Dados - Corresponder Operadores" showSeparator={true}>
                        <ButtonToolbar className="pull-right">
                            <Button onClick={() => this.onImport()}>IMPORTAR</Button>
                            <Button onClick={() => this.onCancel()}>CANCELAR</Button>
                        </ButtonToolbar>
                    </TitleRow>

                    <Grid fluid className="margin-top-10">
                        <Row>
                            <Col sm={12}>
                                {this.renderForm(styles, isTransportAuthority)}
                            </Col>
                        </Row>
                    </Grid>
                </div>

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}

class ProviderMatchProviderStepForm extends Component {
    renderFormHelpBlock(style, message) {
        if (null === style) {
            return null;
        }

        return (
            <HelpBlock>{message}</HelpBlock>
        );
    }

    render() {
        const { providers, form, styles } = this.props;

        return (
            <Form>
                <FormGroup className="margin-bottom-35"
                    controlId={`form-providers`}
                    validationState={styles.providers} >
                    <ControlLabel>Operadores</ControlLabel>
                    <Select className="custom-multiselect"
                        placeholder="Sem Operador Selecionado"
                        noOptionsMessage={() => "Sem Operadores"}
                        onChange={(e) => this.props.onSelectValue(e, "providers")}
                        options={providers}
                        isMulti={true}
                        isClearable={true}
                        isOptionSelected={function (a) {
                            return Array.isArray(form.providers) && form.providers.includes(a);
                        }}
                        getOptionValue={value => value}
                        getOptionLabel={label => label}
                        value={form.providers} />

                    {this.renderFormHelpBlock(styles.providers, "Este campo não pode estar vazio.")}
                </FormGroup>
            </Form>
        );
    }
}

class TransportAuthorityMatchProviderStepForm extends Component {
    renderEditionForm(editions, match) {
        if (null === match.systemProvider || undefined === match.systemProvider || "0" === match.systemProvider.id) {
            return null;
        }

        const providerEditions = editions.filter(a => a.providerId === match.systemProvider.id);

        return (
            <Select className="custom-multiselect margin-top-10"
                placeholder="Sem Edição de Rede Selecionada (Criar Nova)"
                noOptionsMessage={() => "Sem Edições de Rede Configuradas"}
                onChange={(e) => this.props.onSelectValue(match, e, "networkEdition")}
                options={providerEditions}
                isMulti={false}
                isClearable={true}
                isOptionSelected={function (a) {
                    return match.networkEdition === a;
                }}
                getOptionValue={value => value}
                getOptionLabel={label => label.name}
                value={match.networkEdition} />
        );
    }

    render() {
        const { form, providers, editions } = this.props;

        return (
            <Form>
                {
                    form.matches.map(match =>
                        <FormGroup key={`form-${match.readProvider}`}
                            className="margin-bottom-35"
                            controlId={`form-${match.readProvider}`} >
                            <ControlLabel>{match.readProvider}</ControlLabel>

                            <Select className="custom-multiselect"
                                placeholder="Sem Operador Selecionado (Não Importar)"
                                noOptionsMessage={() => "Sem Operadores Configurados"}
                                onChange={(e) => this.props.onSelectValue(match, e, "systemProvider")}
                                options={providers}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    return match.systemProvider === a;
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={match.systemProvider}
                            />

                            {this.renderEditionForm(editions, match)}
                        </FormGroup>
                    )
                }
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/import/steps/MatchProviderStep.js